import { securedAxiosInstance } from "../axios";

class InsurersService {
  fetchIndex() {
    return securedAxiosInstance.get("/insurers");
  }
}

export default new InsurersService();
